import React from 'react'

const FilterKitchen = () => {
  return (
    <div>
      
    </div>
  )
}

export default FilterKitchen
